import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-survey',
  templateUrl: './view-survey.component.html',
  styleUrls: ['./view-survey.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ViewSurveyComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private apicall: ApiCallService,
    private _i18nDynamicTranslate: TranslateDynamicText
  ) { }

  surveyToken = '';
  surveyHtml;
  isCustomerResponse = true;
  loading = false;
  divIdd : any;
  lengg : any;
  count = 0;
  storeName = "";
  surveyName = "";
  imgPath = "https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/gradients/profile1.png";

  submitForm(event) {
    console.log('testttt');
    event.preventDefault();
  }
  ngOnInit(): void {
    console.log("HELLO")
    this.getToken();      
  }
  async getToken(){
    await this.route.queryParams.subscribe((params) => {
      console.log("pa",params["surveyToken"])
      if(params["surveyToken"]){
        console.log("HI")
        this.surveyToken = params["surveyToken"];
        this.isDuplicate();
      }
    });
  }

  isDuplicate(){
    console.log("testt")
    this.apicall.getIsDuplicateSurvey(this.surveyToken).subscribe((resposne)=>{
      this.surveyHtml = resposne['body']['surveyHtml'];
      console.log(this.surveyHtml, resposne['body']['isCustomerResponse'])
      this.isCustomerResponse = resposne['body']['isCustomerResponse'];
      console.log(this.isCustomerResponse)

    if(resposne['body']['storeLogoUrl'] != null)
        this.imgPath = resposne['body']['storeLogoUrl'];
    else
        this.imgPath = "https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/gradients/profile1.png";
    this.storeName = resposne['body']['storeName'];
    this.surveyName = resposne['body']['surveyName'];

    this.surveyHtml = resposne['body']['surveyHtml'];
    console.log(this.surveyHtml, resposne['body']['isCustomerResponse'])
    this.isCustomerResponse = resposne['body']['isCustomerResponse'];
    console.log(this.isCustomerResponse)
    // this.submissionCheckStatus();
    if(this.surveyHtml){
        let parent = document.getElementById("surveyHtml");
        console.log("parent",parent)
        let inputWraper=document.createElement("div");
        let wrapper = this.surveyHtml
        inputWraper.innerHTML = wrapper;
        parent.append(inputWraper);
        this.divIdd = document.getElementById('questionDiv');
        this.lengg = this.divIdd.getElementsByTagName('p').length;
        let button = document.getElementsByTagName('button')[0].setAttribute("type","button");
        let btn = document.getElementById("btn");
        btn.addEventListener('click', event => {
            this.startProcess()
            this.submitForm3();
        });
    }
    if(this.isCustomerResponse === undefined){
        this.displayScreen('delete', resposne['body']);
    }
    if(this.isCustomerResponse === false){
      this.displayScreen('new')
    }
    if(this.isCustomerResponse === true){
      this.displayScreen('old')
    }
    this.loading = true;
    },(err)=>{
      this.displayScreen('error');
    });
    // let resposne = {"message":"SUCCESS","body":{"surveyHtml":"<head><link rel='stylesheet' type='text/css' href='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/scripts/survey-dev.min.css'/>  </head><body><div _ngcontent-txb-c626=\"\"><div _ngcontent-txb-c626=\"\" id=\"mainDiv\" class=\"session-newsurvey\"><div _ngcontent-txb-c626=\"\" class=\"asterisk-mandatory\">All fields marked with an asterisk (<span _ngcontent-txb-c626=\"\" class=\"asterisk-only\">*</span>) are required. </div><form _ngcontent-txb-c626=\"\" novalidate=\"\" id=\"formId\" class=\"ng-untouched ng-pristine ng-valid\" data-hs-cf-bound=\"true\"><div _ngcontent-txb-c626=\"\" id=\"questionDiv\"><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-0\" required=\"true\"> How did you find our delivery service<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"survey-dropdownentry\"><select _ngcontent-txb-c626=\"\" name=\"a12\" class=\"survey-dropdownentry-select\" id=\"S-0\"><option _ngcontent-txb-c626=\"\" value=\"null\" ng-reflect-value=\"null\"></option><option _ngcontent-txb-c626=\"\" value=\"Great\" ng-reflect-value=\"Great\" class=\"ng-star-inserted\"> Great</option><option _ngcontent-txb-c626=\"\" value=\"Good\" ng-reflect-value=\"Good\" class=\"ng-star-inserted\"> Good</option><option _ngcontent-txb-c626=\"\" value=\"Fine\" ng-reflect-value=\"Fine\" class=\"ng-star-inserted\"> Fine</option><option _ngcontent-txb-c626=\"\" value=\"Ok\" ng-reflect-value=\"Ok\" class=\"ng-star-inserted\"> Ok</option><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></select></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-1\" required=\"true\"> How did you like the IPL final 23<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><div _ngcontent-txb-c626=\"\" class=\"di-flex ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Incredible\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Incredible</label><br _ngcontent-txb-c626=\"\"></div><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Rain made it bad\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Rain made it bad</label><br _ngcontent-txb-c626=\"\"></div><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Okaish\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Okaish</label><br _ngcontent-txb-c626=\"\"></div><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-2\" required=\"true\"> Tell us about you experience with us?<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><textarea _ngcontent-txb-c626=\"\" type=\"text\" maxlength=\"1000\" class=\"survey-textarea-input\" id=\"T-2\"></textarea><div _ngcontent-txb-c626=\"\" class=\"survey-textarea-limitvalidation-text\" id=\"V-2\">1000 characters remaining</div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-3\" required=\"true\"> How much would you recommend it to you peers in 0-10<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"slidecontainer\"><input _ngcontent-txb-c626=\"\" type=\"range\" min=\"1\" max=\"10\" value=\"1\" class=\"slider\" id=\"R-3\"></div><div _ngcontent-txb-c626=\"\" class=\"slidernumber-range\"><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">1</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">2</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">3</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">4</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">5</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">6</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">7</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">8</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">9</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">10</div><!--bindings={  \"ng-reflect-ng-for-of\": \"1,2,3,4,5,6,7,8,9,10\"}--></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></div></div></div></div></div><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></div><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"survey-submitarea ng-star-inserted\"><button _ngcontent-txb-c626=\"\" id=\"btn\" type=\"button\" class=\"suvey-submitbuttom\">Submit feedback</button><div _ngcontent-txb-c626=\"\" id=\"validationDiv\" class=\"survey-submitbutton-validationtext\"></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></form></div><div _ngcontent-txb-c626=\"\" id=\"feedbackDiv\" class=\"feedbackdiv-section\"><span _ngcontent-txb-c626=\"\" id=\"feedbackSpan\"></span></div></div><div _ngcontent-txb-c626=\"\" class=\"session-surveycheck\"><div _ngcontent-txb-c626=\"\" class=\"survey-ssr\"><div _ngcontent-txb-c626=\"\" class=\"surveycheck-result-text\"> You have already submitted the survey! </div><img _ngcontent-txb-c626=\"\" src=\"https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Survey_Completion.png\" width=\"350\" height=\"350\" alt=\"\"></div></div><div _ngcontent-txb-c626=\"\" class=\"session-error\"><div _ngcontent-txb-c626=\"\" class=\"session-error-section\"><div _ngcontent-txb-c626=\"\" class=\"surveycheck-result-text\"> Error! Please try again later. </div></div></div><script src='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/scripts/pos/survey-dev.js'></script></body>","isCustomerResponse":false,"surveyCustomerResponseId":null}}
//     let resposne = {"message":"SUCCESS","body":{"surveyHtml":"<head><link rel='stylesheet' type='text/css' href='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/scripts/survey-dev.min.css'/>  </head><body><div _ngcontent-txb-c626=\"\"><div _ngcontent-txb-c626=\"\" id=\"mainDiv\" class=\"session-newsurvey\"><div _ngcontent-txb-c626=\"\" class=\"asterisk-mandatory\">All fields marked with an asterisk (<span _ngcontent-txb-c626=\"\" class=\"asterisk-only\">*</span>) are required. </div><form _ngcontent-txb-c626=\"\" novalidate=\"\" id=\"formId\" class=\"ng-untouched ng-pristine ng-valid\" data-hs-cf-bound=\"true\"><div _ngcontent-txb-c626=\"\" id=\"questionDiv\"><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-0\" required=\"true\"> How did you find our delivery service<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"survey-dropdownentry\"><select _ngcontent-txb-c626=\"\" name=\"a12\" class=\"survey-dropdownentry-select\" id=\"S-0\"><option _ngcontent-txb-c626=\"\" value=\"null\" ng-reflect-value=\"null\"></option><option _ngcontent-txb-c626=\"\" value=\"Great\" ng-reflect-value=\"Great\" class=\"ng-star-inserted\"> Great</option><option _ngcontent-txb-c626=\"\" value=\"Good\" ng-reflect-value=\"Good\" class=\"ng-star-inserted\"> Good</option><option _ngcontent-txb-c626=\"\" value=\"Fine\" ng-reflect-value=\"Fine\" class=\"ng-star-inserted\"> Fine</option><option _ngcontent-txb-c626=\"\" value=\"Ok\" ng-reflect-value=\"Ok\" class=\"ng-star-inserted\"> Ok</option><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></select></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-1\" required=\"true\"> How did you like the IPL final 23<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><div _ngcontent-txb-c626=\"\" class=\"di-flex ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Incredible\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Incredible</label><br _ngcontent-txb-c626=\"\"></div><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Rain made it bad\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Rain made it bad</label><br _ngcontent-txb-c626=\"\"></div><div _ngcontent-txb-c626=\"\" class=\"survey-radioentry ng-star-inserted\"><input _ngcontent-txb-c626=\"\" type=\"radio\" id=\"r\" class=\"survey-radio-input\" name=\"B-1\" value=\"Okaish\"><label _ngcontent-txb-c626=\"\" for=\"male\" class=\"survey-radioentry-text\">Okaish</label><br _ngcontent-txb-c626=\"\"></div><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-2\" required=\"true\"> Tell us about you experience with us?<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><textarea _ngcontent-txb-c626=\"\" type=\"text\" maxlength=\"1000\" class=\"survey-textarea-input\" id=\"T-2\"></textarea><div _ngcontent-txb-c626=\"\" class=\"survey-textarea-limitvalidation-text\" id=\"V-2\">1000 characters remaining</div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--></div></div></div></div></div><div _ngcontent-txb-c626=\"\" class=\"question-section-single ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"surveyarray-head\"><div _ngcontent-txb-c626=\"\" class=\"display-flex-100\"><div _ngcontent-txb-c626=\"\" class=\"width-100\"><div _ngcontent-txb-c626=\"\" class=\"question-head\"><p _ngcontent-txb-c626=\"\" class=\"question-vrfield\" id=\"Q-3\" required=\"true\"> How much would you recommend it to you peers in 0-10<span _ngcontent-txb-c626=\"\" class=\"question-required-marker\"><sup _ngcontent-txb-c626=\"\" class=\"asterisk-only ng-star-inserted\">* </sup><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></span></p></div><div _ngcontent-txb-c626=\"\"><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\"><div _ngcontent-txb-c626=\"\" class=\"slidecontainer\"><input _ngcontent-txb-c626=\"\" type=\"range\" min=\"1\" max=\"10\" value=\"1\" class=\"slider\" id=\"R-3\"></div><div _ngcontent-txb-c626=\"\" class=\"slidernumber-range\"><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">1</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">2</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">3</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">4</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">5</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">6</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">7</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">8</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">9</div><div _ngcontent-txb-c626=\"\" class=\"ng-star-inserted\">10</div><!--bindings={  \"ng-reflect-ng-for-of\": \"1,2,3,4,5,6,7,8,9,10\"}--></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></div></div></div></div></div><!--bindings={  \"ng-reflect-ng-for-of\": \"[object Object],[object Object\"}--></div><!--bindings={  \"ng-reflect-ng-if\": \"false\"}--><div _ngcontent-txb-c626=\"\" class=\"survey-submitarea ng-star-inserted\"><button _ngcontent-txb-c626=\"\" id=\"btn\" type=\"button\" class=\"suvey-submitbuttom\">Submit feedback</button><div _ngcontent-txb-c626=\"\" id=\"validationDiv\" class=\"survey-submitbutton-validationtext\"></div></div><!--bindings={  \"ng-reflect-ng-if\": \"true\"}--></form></div><div _ngcontent-txb-c626=\"\" id=\"feedbackDiv\" class=\"feedbackdiv-section\"><span _ngcontent-txb-c626=\"\" id=\"feedbackSpan\"></span></div></div><div _ngcontent-txb-c626=\"\" class=\"session-surveycheck\"><div _ngcontent-txb-c626=\"\" class=\"survey-ssr\"><div _ngcontent-txb-c626=\"\" class=\"surveycheck-result-text\"> You have already submitted the survey! </div><img _ngcontent-txb-c626=\"\" src=\"https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Survey_Completion.png\" width=\"350\" height=\"350\" alt=\"\"></div></div><div _ngcontent-txb-c626=\"\" class=\"session-error\"><div _ngcontent-txb-c626=\"\" class=\"session-error-section\"><div _ngcontent-txb-c626=\"\" class=\"surveycheck-result-text\"> Error! Please try again later. </div></div></div><script src='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/scripts/pos/survey-dev.js'></script></body>","isCustomerResponse":false,"surveyCustomerResponseId":null,"storeName":"ashish","storeLogoUrl":"https://greyfox-templates-dev.s3.amazonaws.com/shopify/10393/branding/c3w4THS6demoLogo.jpeg","surveyName":"AllQTypes","customerResponse":false}}




//     this.surveyHtml = resposne['body']['surveyHtml'];
//     console.log(this.surveyHtml, resposne['body']['isCustomerResponse'])
//     this.isCustomerResponse = resposne['body']['isCustomerResponse'];
//     if(resposne['body']['storeLogoUrl'] != null)
//         this.imgPath = resposne['body']['storeLogoUrl'];
//     else
//         this.imgPath = "https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/gradients/profile1.png";
//     this.storeName = resposne['body']['storeName'];
//     this.surveyName = resposne['body']['surveyName'];
//     console.log(this.isCustomerResponse)
//     // this.submissionCheckStatus();
//     let parent = document.getElementById("surveyHtml");
//     console.log("parent",parent)
//     let inputWraper=document.createElement("div");
//     let wrapper = this.surveyHtml
//     inputWraper.innerHTML = wrapper;
//     parent.append(inputWraper);
//    this.divIdd = document.getElementById('questionDiv');
//    this.lengg = this.divIdd.getElementsByTagName('p').length;
//    let button = document.getElementsByTagName('button')[0].setAttribute("type","button");
//    let btn = document.getElementById("btn");
//   btn.addEventListener('click', event => {
//     this.submitForm3();
//   });
//    if(this.isCustomerResponse === false){
//     this.displayScreen('new')
//    }
//    if(this.isCustomerResponse === true){
//     this.displayScreen('old')
//    }
  //  let interval = setInterval(this.checkLength, 300);
   let interval = setInterval(() => {
    this.checkLength()
  }, 300);
  }
  submitForm1() {
    console.log("testttt")
  }

  

//    submittingForm = false;
//     divIdd :any
//     lengg : any;
//     data = [];
//     internalData = []
//     finalType; count = 0;
//     length;
// 	 testSurvey=false;

//  submitForm() {
// 	if(this.testSurvey){
// 		return 0;
// 	}
//     var t, n = document.getElementById('questionDiv'),
//         a = n.getElementsByTagName('p').length;
//     length = a;
//     for (let i = 0; i < length; i++) {
//         t = null;
//         this.finalType = null;
//         var x;
//         if (document.getElementsByName('B-' + i).length > 0) {
//             let e : any = document.getElementsByName('B-' + i);
//             let clickCheck = 0;
//             for (let j = 0; j < e.length; j++) {
//                 if (e[j]['checked']) {
//                     t = e[j]['value'];
//                     this.finalType = 'RADIO';
//                 } else {
//                     clickCheck++;
//                     if (clickCheck == e.length) {
//                         t = '';
//                         this.finalType = 'RADIO';
//                     }
//                 }
//             }
//         };
//         if (document.getElementById('S-' + i)) {
//             let e : any = document.getElementById('S-' + i);
//             for (let j = 0; j < e.length; j++) {
//                 if (e[j].selected) {
//                     t = e.options[j].text;
//                     this.finalType = 'DROPDOWN';
//                 }
//             }
//         };
//         if (document.getElementById('T-' + i)) {
//             let e : any  = document.getElementById('T-' + i);
//             t = e.value;
//             this.finalType = 'TEXT';
//         };
//         if (document.getElementById('R-' + i)) {
//             let n : any = document.getElementById('R-' + i)
//             let  x : any = document.getElementById('Q-' + i).getAttribute('required');
//             a = n.getElementsByTagName('div').length;
//             var clickCheck = 0;
//             t = n.value;
//             this.finalType = 'RANGE';
//         };
//         this.submitData((document.getElementById('Q-' + i).innerHTML.split("<span")[0]).replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&').trimStart(), t, this.finalType, document.getElementById('Q-' + i).getAttribute('required'), i);
//     }
// }

//  myFunction(e, n) {
//     var t = e.id;
//     this.resetColor(n);
//     var i = document.getElementById(t);
//     let a : any = window.getComputedStyle(i).backgroundColor;
//     if (a === 'rgb(0, 0, 0)') {
//         document.getElementById(t).style.background = '#4abb59';
//     } else {
//         document.getElementById(t).style.background = '#000';
//     }
// };

// resetColor(e) {
//     var t = document.getElementById('R-' + e),
//         n = t.getElementsByTagName('div').length;
//     for (let i = 1; i <= n; i++) {
//         document.getElementById('demo' + e + i).style.background = '#000';
//     }
// };

// submitData(e, t, n, x, ji) {
//     var i = {
//         'question': e.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
//         'answer': t.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
//         'type': n
//     };
//     this.data.push(i);
//     var p = {
//         'question': e.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
//         'answer': t.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
//         'type': n,
//         'required': x
//     };
//     this.internalData.push(p);
//     if (ji == length - 1) {
//         if (!this.validateForms(this.internalData)) {
//             this.internalData = [];
//             this.data = [];
//             document.getElementById('validationDiv').innerHTML = 'All fields marked with asterisk(*) are required';
//         } else {
//             document.getElementById('validationDiv').innerHTML = '';
// 			this.apiCall(this.data);
//         }
//     }
// };

//  validateForms(dat) {
//     var c = 0;
//     for (c = 0; c < dat.length; c++) {
//         if (dat[c].required == 'true') {
//             if (dat[c].type == 'TEXT') {
//                 if (!this.validateTextArea(c)) {
//                     return !1
//                 }
//             } else {
//                 if (dat[c].answer == null || dat[c].answer == '') {
//                     dat[c].answer = null;
//                     return !1
//                 }
//             }
//         } else {
//             if (dat[c].answer == null || dat[c].answer == '') {
//                 dat[c].answer = '';
//             }
//         }
//         if (c == dat.length - 1) {
//             return true;
//         }
//     }
// }

// formValidation(e) {
//     this.validateTextArea(1);
//     for (let k = 0; k < e.length; k++) {
//         if (!(e[k]['answer'])) {
//             return !0;
//         }
//     };
//     return !1;
// };

apiCall1(e) {
    this.startProcess();
    this.data = [];
    this.count = 0;
    var n = JSON.stringify({
        'list': e,
        'url': window.location.href
    });
    var t :any = new XMLHttpRequest();
    //make it dynamic
    t.open('POST', 'https://'+environment.apiUrl+'/survey/submitFeedback/pos/reviews/', !0); 
    t.setRequestHeader('Content-type', 'application/json');
    t.send(n);
    this.internalData = [];
    this.data = [];
    t.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            this.submittingForm = true;
            document.getElementById('mainDiv').innerHTML = '';
            document.getElementById('feedbackDiv').style.padding = '10%';
            document.getElementById('feedbackSpan').innerHTML = `<div style='dispaly:flex;width:100%;justify-content: center;align-items:center;flex-direction:column; width: 100%; display: flex;'><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; margin-top: 10px; color: #222222;'>Thank you for sharing your thoughts.</div><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; color: #222222;'>We appreciate your feedback.</div><div id='smileySvg'></div></div>`;
        }
        else{
            document.getElementById('validationDiv').innerHTML = 'Something went wrong';
            let button = document.getElementById('btn');
            button.innerHTML = 'Submit feedback'; // Restore button text
        }
    }
};
checkLength() {
    for (let i = 0; i < this.lengg; i++) {
      let e :any= document.getElementById('T-' + i)
        if (e) {
            if (e.value.length <= 1000) {
                if ((1000 - e.value.length) >= 2) {
                    document.getElementById('V-' + i).innerHTML = (1000 - e.value.length) + ' characters remaining';
                } else {
                    document.getElementById('V-' + i).innerHTML = (1000 - e.value.length) + ' character remaining';
                }
            }
        }
    }
}

//  validateTextArea(index) {
//     if (document.getElementById('T-' + index) && document.getElementById('Q-' + index).getAttribute('required')) {
//         var e :any = document.getElementById('T-' + index);
//         if (e.value.trim() == '') {
//             alert('Text area should not be empty');
//             e.focus();
//             return !1;
//         } else {
//             return 1;
//         }
//     }
// };

 displayScreen(screen, data?) {
    if (screen == 'new') {
        // this.submittingForm = false;

        document.getElementsByClassName('session-newsurvey')[0].setAttribute("style", "display:block");
        document.getElementsByClassName('session-surveycheck')[0].setAttribute("style", "display:none");
        document.getElementsByClassName('session-error')[0].setAttribute("style", "display:none");

    } else if (screen == 'old') {
        // this.submittingForm = true;

        // document.getElementsByClassName('session-newsurvey')[0].setAttribute("style", "display:none");
        // document.getElementsByClassName('session-surveycheck')[0].setAttribute("style", "display:block");
        // document.getElementsByClassName('session-error')[0].setAttribute("style", "display:none");
        document.getElementById('mainDiv').innerHTML = '';
        document.getElementById('feedbackDiv').style.padding = '10%';
        document.getElementById('feedbackSpan').innerHTML = ` <div class="qb-session-surveycheck">
            <div class="survey-ssr">
                <div class="surveycheck-result-text">
                    You have already submitted the survey!
                </div>
            </div>
        </div>`
    } else if (screen == 'error') {
        // this.submittingForm = true;

        document.getElementsByClassName('session-newsurvey')[0].setAttribute("style", "display:none");
        document.getElementsByClassName('session-surveycheck')[0].setAttribute("style", "display:none");
        document.getElementsByClassName('session-error')[0].setAttribute("style", "display:block");
    } else if (screen == 'delete'){
        let parent = document.getElementById("surveyHtml");
        let inputWraper=document.createElement("div");
        let wrapper = this.surveyHtml
        inputWraper.innerHTML = ` <div class="qb-session-surveycheck">
            <div class="survey-ssr">
                <div class="surveycheck-result-text">
                    ${data}
                </div>
            </div>
        </div>`;
        parent.append(inputWraper);
    } 
    else {}
}
// // window.onbeforeunload = function() {
// //     if (submittingForm) return undefined;
// //     return 'Are you sure you want to leave?';
// // };
// // window.onload = submissionCheckStatus();

//  submissionCheckStatus() {
//   // this.divIdd = document.getElementById('questionDiv');
//   // this.lengg = this.divIdd.getElementsByTagName('p').length;
//     var d : any = document 
//     d.querySelector('.session-newsurvey').style.display = 'none';
//     d.querySelector('.session-surveycheck').style.display = 'none';
//     var e :any = new XMLHttpRequest;
//     let params = (new URL(e.location)).searchParams;
//     let urlParam = params.get('surveyToken');
// 	if(urlParam=='testEmailToken'){
// 		this.testSurvey=true;
// 		this.displayScreen('new');
// 	}
//     else if (urlParam) {
//         e.onreadystatechange = function() {
//             4 == this.readyState && 200 == this.status && ((JSON.parse(this.responseText).body.length == 0) ? this.displayScreen('new') : this.displayScreen('old')), 4 == this.readyState && 500 == this.status && this.displayScreen('error');
//         };
//         var t = 'https://dev.grayfox.ai/ezloyal-web/survey/duplicateSurvey/shopify/reviews?surveyToken=' + urlParam;
//         e.open('GET', t, !0);
//         e.send();
//     } else {
//         d.querySelector('.session-surveycheck').style.display = 'flex';
//         this.displayScreen('error');
//     }
//     // this.setInterval(checkLength, 300);
  
//   }

finalType= null;
 submitForm3() {
	// if(testSurvey){
	// 	return 0;
	// }
    var t, n = document.getElementById('questionDiv'),
        a = n.getElementsByTagName('p').length;
        console.log("Length",a)
    length = a;
    for (let i = 0; i < length; i++) {
        t = null;
        this.finalType = null;
        var x;
        console.log(document.getElementsByName('B-' + i))
        if (document.getElementsByName('B-' + i).length > 0) {
            var e :any = document.getElementsByName('B-' + i);
            var clickCheck = 0;
            for (let j = 0; j < e.length; j++) {
                if (e[j].checked) {
                    t = e[j].value;
                    this.finalType = 'RADIO';
                } else {
                    clickCheck++;
                    if (clickCheck == e.length) {
                        t = '';
                        this.finalType = 'RADIO';
                    }
                }
            }
        }
        if (document.getElementById('S-' + i)) {
            var e: any = document.getElementById('S-' + i);
            for (let j = 0; j < e.length; j++) {
                if (e[j].selected) {
                    t = e.options[j].text;
                    this.finalType = 'DROPDOWN';
                }
            }
        }
        if (document.getElementById('T-' + i)) {
            var e :any = document.getElementById('T-' + i);
            t = e.value;
            this.finalType = 'TEXT';
        }
        if (document.getElementById('R-' + i)) {
            let n = document.getElementById('R-' + i)
                x = document.getElementById('Q-' + i).getAttribute('required');
            a = n.getElementsByTagName('div').length;
            var clickCheck = 0;
            t = n['value'];
            this.finalType = 'RANGE';
        }
        this.submitData((document.getElementById('Q-' + i).innerHTML.split("<span")[0]).replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&').trimStart(), t, this.finalType, document.getElementById('Q-' + i).getAttribute('required'), i);
    }
  }
  data = [];
  internalData = []
submitData(e, t, n, x, ji) {
  console.log("e",e, "t", t,"n", n,"x", x,"ji", ji)
  var i = {
      'question': e.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
      'answer': t.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
      'type': n
  };
  this.data.push(i);
  var p = {
      'question': e.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
      'answer': t.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&'),
      'type': n,
      'required': x
  };
  this.internalData.push(p);
  console.log("leggg",length,this.internalData,this.data)
  if (ji == length - 1) {
      if (!this.validateForms(this.internalData)) {
          this.internalData = [];
          this.data = [];
          document.getElementById('validationDiv').innerHTML = this._i18nDynamicTranslate.transform('All fields marked with asterisk(*) are required', ['STATIC_PAGE']);
          this.endProcess();
      } else {
          document.getElementById('validationDiv').innerHTML = '';
    this.apiCall1(this.data);
      }
  }
};
apiCall(data){
  console.log("SUCESS",data);
}
 validateForms(dat) {
  console.log("tdystyd", dat)
  var c = 0;
  for (c = 0; c < dat.length; c++) {
      if (dat[c].required == 'true') { 
          if (dat[c].type == 'TEXT') {
              if (!this.validateTextArea(c)) {
                  return !1
              }
          } else {
              if (dat[c].answer == null || dat[c].answer == '') {
                  dat[c].answer = null;
                  return !1
              }
          }
      } else {
          if (dat[c].answer == null || dat[c].answer == '') {
              dat[c].answer = '';
          }
      }
      if (c == dat.length - 1) {
          return true;
      }
  }
}
 validateTextArea(index) {
   console.log("eee",index)
  if (document.getElementById('T-' + index) && document.getElementById('Q-' + index).getAttribute('required')) {
    console.log("test entry")
      var e = document.getElementById('T-' + index);
      if (e['value'].trim() == '') {
          alert(this._i18nDynamicTranslate.transform('Text area should not be empty', ['STATIC_PAGE']));
          e.focus();
          return !1;
      } else {
          return 1;
      }
  }
};
startProcess() {
    let button = document.getElementById('btn');
    let buttonText = button.innerText;
    let spinner = `<div class="spinner-container"><div class="spinner"></div></div>`
    button.innerHTML = spinner
    
    // Simulate a process (e.g., an API request) for demonstration purposes
    // setTimeout(() => {
    //   // After the process completes, revert back to the original button content
    //   button.innerHTML = buttonText; // Restore button text
    // }, 2000); // Simulated delay of 2 seconds
  }
  endProcess(){
    let button = document.getElementById('btn');
    button.innerHTML = 'Submit feedback'; // Restore button text
  }
  
}
